//* Names the background color of a swatch with ntc, and renames it when the color changes.
//*   <div data-controller="name-that-color">
//*     <div class="bg-primary" data-name-that-color-target="color"></div>
//*     <span data-name-that-color-target="name"></span>
//*   </div>
import ApplicationController from "application_controller.js";
import ntc from "../../../../vendor/assets/ntc/ntc.js";
import { useColorHelper } from "mixins";

export default class extends ApplicationController {
  debug = false;

  static targets = ["value", "closest", "name", "exact", "color"];

  connect() {
    this.log_function("connect");

    useColorHelper(this);
    this.ntc = ntc.init();

    //* Initially set the value
    const computedStyle = getComputedStyle(this.colorTarget);
    this.outputdata(computedStyle.backgroundColor);

    //* check if the color changes
    this.observeBackgroundColor(this.colorTarget, this.outputdata.bind(this));
  }

  disconnect() {
    this.log_function("disconnect");
    this.disconnectObserver();
  }

  outputdata(color){
    const color_hex = this.rgb_to_hex(color);
    const match = ntc.name(color_hex);

    if (this.hasValueTarget) {
      this.valueTarget.textContent = color_hex; //* HEX value of tested color
    }

    if (this.hasClosestTarget) {
      this.closestTarget.textContent = match[0]; //* RGB value of closest match
    }

    if (this.hasNameTarget) {
      this.nameTarget.textContent = match[1]; //* Text string: Color name
    }

    if (this.hasExactTarget) {
      this.exactTarget.textContent = match[2]; //* True if exact color match
    }
  }

  //* The color tools set CSS variables on <html>, not on the swatch, so watch the
  //* style of both and re-read the swatch's computed color.
  observeBackgroundColor(element, callback) {
    this.observer = new MutationObserver(() => {
      const backgroundColor = window.getComputedStyle(element).backgroundColor;
      callback(backgroundColor);
      this.log_function(
        "observeBackgroundColor",
        `Background color changed to: ${backgroundColor}`,
      );
    });
    this.observer.observe(element, { attributeFilter: ["style"] });
    this.observer.observe(document.documentElement, { attributeFilter: ["style"] });
  }

  disconnectObserver() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}
